import useAppDispatch from 'hooks/useAppDispatch';
import { facebookLoginAction } from 'store/modules/auth/actions';
import FacebookLogin from 'react-facebook-login';
import { Button } from '@mui/material';
import { SocialIcon } from 'react-social-icons';
import { useStyles } from './styles';

interface FacebookButtonProps {
  isCompany: boolean;
}

function FacebookButton({ isCompany }: FacebookButtonProps) {
  const styles = useStyles();
  const dispatch = useAppDispatch();

  const onSuccess = (data: any) => {
    if (data.accessToken) {
      dispatch(facebookLoginAction(data.accessToken, isCompany));
    }
  };

  const onFailure = (error: any) => {
    console.error(error);
  };

  return (
    <Button fullWidth variant="outlined">
      <FacebookLogin
        cssClass={styles.facebookComponent}
        appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID || ''}
        fields="name,email,picture"
        callback={onSuccess}
        onFailure={onFailure}
        icon={
          <SocialIcon
            bgColor="#590A9D"
            fgColor="white"
            network="facebook"
            style={{ width: 20, height: 20 }}
          />
        }
        textButton="ENTRAR COM FACEBOOK"
      />
    </Button>
  );
}

export default FacebookButton;
